import { Box, BoxProps, styled } from '@mui/material';

export const CenteredContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'backgroundImage',
})<BoxProps & { backgroundImage?: string }>(({ backgroundImage }) => ({
  backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none',
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '20px',
}));
